/*
 * @Description: 首页路由
 * @Author: ywl
 * @Date: 2021-03-02 11:43:53
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2021-08-28 18:44:28
 */
import { RouteConfig } from "vue-router";

import PView from "../layouts/view.vue";

let globalName: any = "龙艺秀";
switch (window.location.hostname) {
  case "www.longyixiu.com":
  case "longyixiu.com":
    globalName = "龙艺秀";
    break;
  case "www.wenjuanjia.com":
  case "wenjuanjia.com":
  case "192.168.1.138":
    globalName = "问卷家";
    break;
  default:
    globalName = "龙艺秀";
    break;
}

const homeRoutes: RouteConfig[] = [
  {
    path: "/",
    meta: { title: "主页" },
    component: PView,
    // redirect: '/',
    children: [
      {
        path: "/",
        name: "homeIndex",
        component: () => import("@/views/home/index.vue"),
        meta: { title: "首页", parentTab: "home" },
      },
    ],
  },
  {
    path: "/index",
    redirect: "/",
  },
  {
    path: "/home",
    redirect: "/",
  },
  // {
  //   path: '/home',
  //   meta: { title: '主页' },
  //   component: PView,
  //   redirect: '/index',
  //   children: [
  //     {
  //       path: '/index',
  //       name: 'homeIndex',
  //       component: () => import('@/views/home/index.vue'),
  //       meta: { title: '首页' },
  //     },
  //   ],
  // },
  // {
  //   path: '/home/list',
  //   meta: { title: '我的活动管理' },
  //   name: 'homeIndexList',
  //   component: () => import('@/views/home/index_list.vue'),

  // },
  {
    path: "/home/vote",
    meta: { title: "主页_投票评选" },
    component: PView,
    redirect: "/index/vote",
    children: [
      {
        path: "/index/vote",
        name: "homeIndexVote",
        component: () => import("@/views/home/index_vote.vue"),
        meta: {
          title: `${globalName}_免费投票评选制作平台`,
          parentTab: "home_voting",
        },
      },
    ],
  },
  {
    path: "/home/form",
    meta: { title: "主页_报名表单" },
    component: PView,
    redirect: "/index/form",
    children: [
      {
        path: "/index/form",
        name: "homeIndexForm",
        component: () => import("@/views/home/index_form.vue"),
        meta: {
          title: `${globalName}_免费报名表单制作平台`,
          parentTab: "home_form",
        },
      },
    ],
  },
  {
    path: "/home/survey",
    meta: { title: "主页_问卷调研" },
    component: PView,
    redirect: "/index/survey",
    children: [
      {
        path: "/index/survey",
        name: "homeIndexSurvey",
        component: () => import("@/views/home/index_survey.vue"),
        meta: {
          title: `${globalName}_免费问卷调研制作平台`,
          parentTab: "home_survey",
        },
      },
    ],
  },
  {
    path: "/home/exam",
    meta: { title: "主页_考试评测" },
    component: PView,
    redirect: "/index/exam",
    children: [
      {
        path: "/index/exam",
        name: "homeIndexExam",
        component: () => import("@/views/home/index_exam.vue"),
        meta: {
          title: `${globalName}_免费考试测评制作平台`,
          parentTab: "home_exam",
        },
      },
    ],
  },
  {
    path: "/home/solitaire",
    meta: { title: "主页_在线接龙" },
    component: PView,
    redirect: "/index/solitaire",
    children: [
      {
        path: "/index/solitaire",
        name: "homeIndexSolitaire",
        component: () => import("@/views/home/index_solitaire.vue"),
        meta: {
          title: `${globalName}_免费打卡接龙制作平台`,
          parentTab: "home_solitaire",
        },
      },
    ],
  },
  {
    path: "/home/online",
    meta: { title: "主页_在线收款" },
    component: PView,
    redirect: "/index/online",
    children: [
      {
        path: "/index/online",
        name: "homeIndexOnline",
        component: () => import("@/views/home/index_online.vue"),
        meta: {
          title: `${globalName}_免费在线收款制作平台`,
          parentTab: "home_online",
        },
      },
    ],
  },
  {
    path: "/home/order",
    meta: { title: "主页_在线预约" },
    component: PView,
    redirect: "/index/order",
    children: [
      {
        path: "/index/order",
        name: "homeIndexOrder",
        component: () => import("@/views/home/index_order.vue"),
        meta: {
          title: `${globalName}_免费在线预约制作平台`,
          parentTab: "home_order",
        },
      },
    ],
  },
  // {
  //   path: '/home/evaluation',
  //   meta: { title: '主页_在线评测' },
  //   component: PView,
  //   redirect: '/index/evaluation',
  //   children: [
  //     {
  //       path: '/index/evaluation',
  //       name: 'homeIndexEvaluation',
  //       component: () => import('@/views/home/index_evaluation.vue'),
  //       meta: { title: '首页_在线评测' },
  //     },
  //   ],
  // },
  {
    path: "/x/:id",
    name: "x",
    component: () => import("@/views/x.vue"),
  },
  {
    path: "/login",
    name: "loginIndex",
    meta: { title: "登录" },
    component: () => import("@/views/login/index.vue"),
  },
  {
    path: "/auth",
    name: "auth",
    meta: { title: "授权登录" },
    component: () => import("@/views/auth.vue"),
  },
  {
    path: "/authH5",
    name: "authH5",
    meta: { title: "邀请函授权登录" },
    component: () => import("@/views/authH5.vue"),
  },
  {
    path: "/H5qyWechat",
    name: "H5qyWechat",
    meta: { title: "邀请函企业微信" },
    component: () => import("@/views/H5qyWechat.vue"),
  },

  {
    path: "/proList.html",
    meta: { title: "列表数据" },
    component: () => import("@/components/table/gongge/problemList.vue"),
  },
  {
    path: "/collection.html",
    meta: { title: "我的收藏" },
    component: () => import("@/views/collection/index.vue"),
  },
  {
    path: "/myDownload.html",
    meta: { title: "我的下载" },
    component: () => import("@/views/myDownload/index.vue"),
  },
];

// const loginRoutes: RouteConfig[] = [
//   {
//     path: '/login',
//     meta: { title: '登录' },
//     component: () => import('@/views/login/login.vue')
//   },
// ];

export { homeRoutes };
